__turbopack_context__.v({
  "actions": "CommunicationStylePanel-module__m4uQ3q__actions",
  "bandLabel": "CommunicationStylePanel-module__m4uQ3q__bandLabel",
  "counter": "CommunicationStylePanel-module__m4uQ3q__counter",
  "counterNearLimit": "CommunicationStylePanel-module__m4uQ3q__counterNearLimit",
  "dimension": "CommunicationStylePanel-module__m4uQ3q__dimension",
  "dimensionHeader": "CommunicationStylePanel-module__m4uQ3q__dimensionHeader",
  "dimensionName": "CommunicationStylePanel-module__m4uQ3q__dimensionName",
  "dimensions": "CommunicationStylePanel-module__m4uQ3q__dimensions",
  "extremes": "CommunicationStylePanel-module__m4uQ3q__extremes",
  "guidance": "CommunicationStylePanel-module__m4uQ3q__guidance",
  "guidanceTrigger": "CommunicationStylePanel-module__m4uQ3q__guidanceTrigger",
  "intro": "CommunicationStylePanel-module__m4uQ3q__intro",
  "panel": "CommunicationStylePanel-module__m4uQ3q__panel",
  "saved": "CommunicationStylePanel-module__m4uQ3q__saved",
  "savedIcon": "CommunicationStylePanel-module__m4uQ3q__savedIcon",
  "status": "CommunicationStylePanel-module__m4uQ3q__status",
});
